import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiExportReceiptsCsv(productIdsAsString:string, sampleCardId: number, allSampleCards:boolean, pigmentsUnit: any, baseUnit: any):
    Promise<AxiosResponse> {
    return API.get(`${config.serverUrl}/api/exportreceiptscsv/${productIdsAsString}/${sampleCardId}/${allSampleCards}/${pigmentsUnit}/${baseUnit}`,
        { responseType: 'blob' });
}
